import * as v from "valibot";

/** The lanes of `GEN_LANES` (content/genStatus.ts), repeated here because the content subpath is server-only. */
const lane = v.picklist(["articles", "narration"]);
const laneState = v.picklist(["idle", "working", "paused", "off"]);

export const adminGeneratorInstanceDto = v.object({
  id: v.string(),
  lifecycleState: v.string(),
  healthStatus: v.string(),
});
export type AdminGeneratorInstance = v.InferOutput<typeof adminGeneratorInstanceDto>;

export const adminGeneratorHostDto = v.object({
  /** Null when no group is configured (a local run). */
  groupName: v.nullable(v.string()),
  desired: v.number(),
  inService: v.number(),
  instances: v.array(adminGeneratorInstanceDto),
});
export type AdminGeneratorHost = v.InferOutput<typeof adminGeneratorHostDto>;

export const adminGeneratorHeartbeatDto = v.object({
  workerId: v.string(),
  seenAt: v.number(),
  lanes: v.nullable(v.record(lane, laneState)),
  limitedUntil: v.nullable(v.number()),
});
export type AdminGeneratorHeartbeat = v.InferOutput<typeof adminGeneratorHeartbeatDto>;

export const adminGeneratorSwitchDto = v.object({ lane, on: v.boolean() });
export type AdminGeneratorSwitch = v.InferOutput<typeof adminGeneratorSwitchDto>;

export const getAdminGeneratorResponse = {
  host: adminGeneratorHostDto,
  heartbeat: v.nullable(adminGeneratorHeartbeatDto),
  switches: v.array(adminGeneratorSwitchDto),
  now: v.number(),
};
export type GetAdminGeneratorResponse = v.InferOutput<v.ObjectSchema<typeof getAdminGeneratorResponse, undefined>>;

export const putAdminGeneratorHostRequest = { on: v.boolean() };

export const putAdminGeneratorSwitchRequest = { lane, on: v.boolean() };

export const getAdminGeneratorLogsRequest = { since: v.optional(v.string()) };

export const adminLogEventDto = v.object({ id: v.string(), timestamp: v.number(), message: v.string() });
export type AdminLogEvent = v.InferOutput<typeof adminLogEventDto>;

export const getAdminGeneratorLogsResponse = { events: v.array(adminLogEventDto) };
export type GetAdminGeneratorLogsResponse = v.InferOutput<v.ObjectSchema<typeof getAdminGeneratorLogsResponse, undefined>>;
